module.exports = __webpack_public_path__ + "img/head-mb.d63e65d1.webp";